import React, { Suspense } from 'react';
import { Routes, Route } from "react-router-dom";
import { useTranslation } from 'react-i18next';

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index"
import PermissionGate from "../Components/PermissionGate";
//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';


// Loading component for lazy routes
const LoadingFallback = () => {
  const { t } = useTranslation();
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">{t('common.loading')}</span>
      </div>
    </div>
  );
};

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <NonAuthLayout>
                  <Suspense fallback={<LoadingFallback />}>
                    {route.component}
                  </Suspense>
                </NonAuthLayout>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>
                    <Suspense fallback={<LoadingFallback />}>
                      <PermissionGate requiredPermissions={route.requiredPermissions}>
                        {route.component}
                      </PermissionGate>
                    </Suspense>
                  </VerticalLayout>
                </AuthProtected>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
